import styled from 'styled-components';
import tw from 'twin.macro';

/**
 * Data table primitives. Wrap in `TableWrap` for horizontal scrolling on
 * small screens; place inside a `Card` with `CardBody $padding="none"`.
 */
export const TableWrap = styled.div`
  ${tw`w-full min-w-0 overflow-x-auto`}
  border-radius: inherit;
`;

export const Table = styled.table`
  ${tw`w-full text-sm text-left border-collapse`}
  color: var(--color-text-primary);
`;

export const THead = styled.thead`
  background-color: var(--color-bg-secondary);
`;

export const TH = styled.th<{ $align?: 'left' | 'right' | 'center'; $width?: string }>`
  ${tw`px-4 py-2.5 text-xs font-semibold uppercase tracking-wider whitespace-nowrap`}
  color: var(--color-text-secondary);
  border-bottom: 1px solid var(--color-border);
  text-align: ${({ $align = 'left' }) => $align};
  ${({ $width }) => $width && `width: ${$width};`}
`;

export const TBody = styled.tbody``;

export const TR = styled.tr<{ $interactive?: boolean; $selected?: boolean }>`
  & + & td {
    border-top: 1px solid var(--color-border);
  }
  background-color: ${({ $selected }) =>
    $selected ? 'rgb(var(--color-black-rgb) / 0.04)' : 'transparent'};
  ${({ $interactive }) =>
    $interactive &&
    `
    cursor: pointer;
    transition: background-color var(--transition-normal);
    &:hover { background-color: var(--color-bg-secondary); }
  `}
`;

export const TD = styled.td<{
  $align?: 'left' | 'right' | 'center';
  $muted?: boolean;
  $nowrap?: boolean;
}>`
  ${tw`px-4 py-3 align-middle`}
  text-align: ${({ $align = 'left' }) => $align};
  ${({ $muted }) => $muted && 'color: var(--color-text-secondary);'}
  ${({ $nowrap }) => $nowrap && 'white-space: nowrap;'}
`;

/** Right-aligned cell for row actions. */
export const TDActions = styled(TD)`
  ${tw`text-right whitespace-nowrap`}
  & > * + * {
    margin-left: 8px;
  }
`;
